import * as table from './TableData'
import { currentDate_dmy , date_dmy_func, GET_ERP_IMG , CurrentTime, GET_COMPANY_FROM_URL } from '../../../../components/Common/CommonFunction';
import { numberWithCommas } from '../../../../Reports/Report_common_function';


let initial_y = 0;

/* ================= BORDER ================= */
export const pageBorder = (doc) => {
  doc.setDrawColor(0, 0, 0);
  doc.line(570, 16, 30, 16);
  doc.line(30, 815, 30, 16);
  doc.line(570, 815, 570, 16);
  doc.line(570, 815, 30, 815);
};

/* ================= HEADER ================= */
export const pageHeder = (doc) => {
  const logo = localStorage.getItem(
    `${GET_COMPANY_FROM_URL()}_CompanyLogo`
  );

  if (logo) {
    doc.addImage(logo, 'PNG', 33, 1, 95, 80, null, 'FAST');
  }

  doc.setFont('Arial', 'bold');
  doc.setFontSize(18);
  doc.text('WASTAGE LIST', 200, 45);
  doc.setDrawColor(0, 0, 0);
  doc.line(570, 63, 30, 63);
};

/* ================= HEADER INFO ================= */
export const reportHeder1 = (doc, data) => {
  doc.setFont('Tahoma', 'bold');
  doc.setFontSize(9);

  doc.text(`Wastage No : ${data.WastagefullNumber || data.WastageNo}`, 35, 75);
  doc.text(`Date : ${date_dmy_func(data.WastageDate)}`, 380, 75);
  doc.line(570, 80, 30, 80);
  doc.text(`Party : ${data.PartyName}`, 35, 90);
  doc.line(570, 95, 30, 95);
  doc.text(`Remarks : ${data.Remarks || '-'}`, 35, 105);
  initial_y = 113;
};

/* ================= TABLE ================= */
export const tableBody = (doc, data) => {
    doc.autoTable({
      head: [table.columns],
      body: table.Rows(data),
      startY: initial_y,
  
      margin: { left: 30, right: 25 },
      theme: 'grid',
  
      tableLineColor: [0, 0, 0],
      tableLineWidth: 1,
  
      styles: {
        fontSize: 9,
        cellPadding: 4,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.8,
      },
  
      headStyles: {
        fontStyle: 'bold',
        fillColor: false,
        textColor: [0, 0, 0],
        lineWidth: 1,
      },
  
      bodyStyles: {
        lineWidth: 0.6,
      },
  
      // 🔥 Highlight TOTAL row
      didParseCell: (data) => {
        if (data.row.index === data.table.body.length - 1) {
          data.cell.styles.fontStyle = 'bold';
          data.cell.styles.lineWidth = 1;
        }
      },
  
      columnStyles: {
        0: { halign: 'center', cellWidth: 35 },  // Sr
        1: { cellWidth: 140 },                   // Item Name
        2: { halign: 'left', cellWidth: 140 , overflow: 'linebreak'},   // Quantity
        3: { halign: 'right', cellWidth: 70 },   // Rate
        4: { halign: 'right', cellWidth: 80 },   // Amount
        5: { halign: 'right' },                    // Remarks
      },
    });
  };
  
  
/* ================= FOOTER ================= */
export const pageFooter = (doc, data) => {
  doc.setFont('Tahoma', 'bold');
  doc.setFontSize(9);
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    pageHeder(doc);
    pageBorder(doc);
    doc.setFontSize(8);
    doc.text(
      'Print Date : ' + String(currentDate_dmy) + '  Time ' + String(CurrentTime()),
      30,
      828
    );
    doc.text(`Page ${i} of ${pageCount}`, 500, 828);
  }
};
